export const defaultLocale = 'de';
export const locales = ['en', 'de'];
export const localeNames = {
    en: 'English',
    de: 'Deutsch'
};
